import type {
  SubcontractorComplianceDocumentType,
  SubcontractorComplianceState
} from "../types/types.ts"

export const COMPLIANCE_STATUS_COLOR_MAP: Record<
  SubcontractorComplianceState,
  string
> = {
  valid: "green",
  expiring_soon: "gold",
  expired: "red",
  no_expiry: "default"
}

export const COMPLIANCE_DOCUMENT_LABELS: Record<string, string> = {
  workers_comp: "Workers' Comp",
  general_liability: "General Liability",
  license: "License",
  w9: "W-9",
  miscellaneous: "Miscellaneous"
}

// Fixed reading order; the API returns only what the subcontractor supplied.
export const COMPLIANCE_DOCUMENT_ORDER = Object.keys(COMPLIANCE_DOCUMENT_LABELS)

// Mirrors the server's own check (`documents.validate_document_file`).
export const COMPLIANCE_DOCUMENT_EXTENSIONS = ["pdf", "png", "jpg", "jpeg"]
export const COMPLIANCE_DOCUMENT_MAX_MB = 10

// The three document types the profile page (and, per EAD-1322, the list's
// compliance column) treat as "always relevant" — missing or not, that's
// worth surfacing. W-9 and Miscellaneous stay data-driven everywhere (shown
// only when supplied): W-9 already has its own edit-form field, and
// Miscellaneous has no per-type identity to attach an action or a "missing"
// verdict to. One shared list so the profile page and the list column can
// never drift on which types count as "missing".
export const TRACKED_COMPLIANCE_DOCUMENT_TYPES: SubcontractorComplianceDocumentType[] =
  ["workers_comp", "general_liability", "license"]
